export const frappeConfig = {
    company: "BuildX",
    posProfile: "Antico",
};

export const isRoleAdmin = (role) => {
    return role === "admin" || role === "Admin" || role === "POS-ADMIN" || role === "Administrator";
};

export const isRoleService = (role) => {
    return role === "Service";
};

export const isRolePos = (role) => {
    return role === "Cashier";
};
